import { Helmet } from 'react-helmet-async';
import React from "react";

const SEO = ({ seoData, schemaData }) => {
  const seo = seoData && !Array.isArray(seoData) ? seoData : {};
  const schema = schemaData && !Array.isArray(schemaData) ? schemaData : {};

  if (
    Object.keys(seo).length === 0 &&
    Object.keys(schema).length === 0
  ) return null;

  const hasSeo = Object.keys(seo).length > 0;
  const title = seo.meta_title || seo.og_title || 'Saysha';
  const description = seo.description || seo.og_description || seo.meta_twitter_description || '';
  const image = seo.og_image_url || seo.meta_twitter_image;

  return (
    <Helmet>
      {hasSeo && (
        <>
          {/* Basic Meta Tags */}
          <title>{title}</title>
          <meta name="keywords" content={seo?.keywords || ''} />
          <meta name="description" content={description} />
          {(seo?.canonical_tag || seo?.url) && <link rel="canonical" href={seo?.canonical_tag || seo?.url} />}

          {/* Open Graph Meta Tags */}
          <meta property="og:locale" content={seo?.og_locale || 'en_US'} />
          <meta property="og:type" content={seo?.og_type || 'website'} />
          <meta property="og:title" content={seo?.og_title || title} />
          <meta property="og:description" content={seo?.og_description || description} />
          {(seo?.og_url || seo?.url) && <meta property="og:url" content={seo?.og_url || seo?.url} />}
          <meta property="og:site_name" content={seo?.og_site_name || 'Saysha'} />
          {image && <meta property="og:image" content={image} />}

          {/* Twitter Meta Tags */}
          <meta name="twitter:card" content={seo?.meta_twitter_card || 'summary_large_image'} />
          {seo?.meta_twitter_site && <meta name="twitter:site" content={seo.meta_twitter_site} />}
          <meta name="twitter:title" content={seo?.meta_twitter_title || title} />
          <meta name="twitter:description" content={seo?.meta_twitter_description || description} />
          {image && <meta name="twitter:image" content={image} />}
          {seo?.meta_twitter && <meta name="twitter:creator" content={seo.meta_twitter} />}
        </>
      )}

      {/* Faq Schema */}
      {seo?.faq_schema && (
        <script type="application/ld+json">
          {(seo.faq_schema)}
        </script>
      )}
      {seo?.article_schema && (
        <script type="application/ld+json">
          {(seo.article_schema)}
        </script>
      )}

      {seo?.local_schema && (
        <script type="application/ld+json">
          {(seo.local_schema)}
        </script>
      )}

      {seo?.video_schema && (
        <script type="application/ld+json">
          {(seo.video_schema)}
        </script>
      )}
      {seo?.product_schema && (
        <script type="application/ld+json">
          {(seo.product_schema)}
        </script>
      )}


      {schema.review_schema && (
        <script type="application/ld+json">
          {(schema.review_schema)}
        </script>
      )}
      
      {schema.organization_schema && (
        <script type="application/ld+json">
          {(schema.organization_schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
